import { Reducer } from 'redux';
import { produce } from 'immer';
import { STATUS_OBJ } from 'utils/statusEnum';
import { OPENCLAIM_TYPES, OpenClaimState } from './types';

export const INITIAL_STATE: OpenClaimState = {
  draftId: null,
  errorDraft: null,
  successDraft: null,
  currentStep: 0,
  unlockedSteps: 1,
  stepsArray: [1, 2, 3, 4, 5],
  destiny: 'stay',
  banklist: null,
  coverage: null,
  franchise: null,
  user: null,
  step: {
    step1: null,
    step2: null,
    step3: null,
    step4: null,
  },
  status: STATUS_OBJ.Draft,
  finalId: '',
};

const reducer: Reducer<OpenClaimState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case OPENCLAIM_TYPES.SET_DRAFT_ID:
      case OPENCLAIM_TYPES.RECOVER_DRAFT:
        draft.draftId = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_RECOVER_DRAFT:
        draft.step = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_ERROR_DRAFT:
        draft.errorDraft = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_SUCCESS_DRAFT:
        draft.successDraft = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_CURRENT_STEP:
        draft.currentStep = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_UNLOCKED_STEPS:
        draft.unlockedSteps = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_DATA_BANKLIST:
        draft.banklist = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_DATA_COVERAGELIST:
        draft.coverage = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_DATA_USER:
        draft.user = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_USER_FRANCHISE:
        draft.franchise = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_DATA_STEP:
        draft.step[action.payload.step] = {
          ...draft.step[action.payload.step],
          ...action.payload.data,
        };
        draft.destiny = action.payload.destiny;
        break;

      case OPENCLAIM_TYPES.SET_UPLOAD_DOCUMENT:
        if (draft.step.step4?.files) {
          draft.step.step4.files = [
            ...draft.step.step4.files,
            ...action.payload,
          ];
        } else {
          draft.step.step4 = { files: [...action.payload] };
        }
        break;
      case OPENCLAIM_TYPES.SET_DELETE_DOCUMENT:
        draft.step.step4.files = action.payload;
        break;
      case OPENCLAIM_TYPES.CLEAR_DATA_STEP:
        return INITIAL_STATE;
      case OPENCLAIM_TYPES.SET_STEPS_ARRAY:
        draft.stepsArray = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_STATUS:
        draft.status = action.payload;
        break;
      case OPENCLAIM_TYPES.SET_FINAL_ID:
        draft.finalId = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
